import Login from "./Login";
import Profile from "./Profile";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../../Firebase/InitFirebase";
import { useState, useEffect } from "react";

export default function LoginOrProfile(){

    const [is_user_signed_in, set_is_user_signed_in] = useState(false);
    const [auth_checked, set_auth_checked] = useState(false);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, currentUser => {
            const isEmailPasswordUser = currentUser?.providerData[0]?.providerId === "password";
            if(currentUser && (!isEmailPasswordUser || currentUser.emailVerified)) set_is_user_signed_in(true);
            else if(!currentUser) set_is_user_signed_in(false);
            set_auth_checked(true);
        })
        return () => unsubscribe();
    }, []);
    
    return(
        // Just render black page for intermeddiary state, othwise weird flash happens
        auth_checked ? (is_user_signed_in ? <Profile/> : <Login/>) : <></>
    );
}